import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription, Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { AuthService } from '../../../../shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  hasError: boolean;
  returnUrl: string;
  isLoading$: Observable<boolean>;
  lang:string;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private msg :NzMessageService,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en');
    this.lang = localStorage.getItem('lang') || 'en';
    this.translate.use(this.lang);
    document.documentElement.lang = this.lang;

  }

  ngOnInit(): void {
    this.initForm();
    this.lang = localStorage.getItem('lang');
  }
  initForm() {

    this.loginForm = this.fb.group({
      email: [
       null,
        Validators.compose([
          Validators.required,
          Validators.email,
          Validators.minLength(3),
          Validators.maxLength(320), // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
        ]),
      ],
      password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
        ]),
      ],
    });
  }


  submitLogin() {
    this.hasError = false;
    let params={
      "email":this.loginForm.value.email,
      "password":this.loginForm.value.password
    }
    this.authService.login(params).subscribe(
      (res: any) => {
      
        this.router.navigate(['admin/dashboard']);
        this.msg.success(res.message);
        localStorage.setItem('token',res.data['token'])

      },
      (err) => {
        this.msg.error(err.message);
      }
    );
}

}
